import script from "./VitaModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./VitaModal.vue?vue&type=script&lang=ts&setup=true"

import "./VitaModal.vue?vue&type=style&index=0&id=043d5f72&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-043d5f72"]])

export default __exports__